'use client';

import { usePathname, useRouter } from 'next/navigation';
import { lazy, memo, Suspense, useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { prefetchAuthChunks } from '../../../components/auth/prefetchAuthChunks';

// import { prefetchAuthChunks } from '../../../components/forms/prefetchAuthChunks';

const AuthModal = lazy(() => import('../../../components/forms/AuthModal'));

// ✅ prefetch самой модалки (потому что она lazy)
let authModalPrefetched: Promise<unknown> | null = null;
function prefetchAuthModal() {
  if (!authModalPrefetched) {
    authModalPrefetched = import('../../../components/forms/AuthModal').catch(() => {
      authModalPrefetched = null;
    });
  }
  return authModalPrefetched;
}

// ✅ общий prefetch (модалка + формы)
function prefetchAllAuth() {
  void prefetchAuthModal();
  void prefetchAuthChunks();
}

function AuthLinks() {
  const router = useRouter();
  const pathname = usePathname();
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [authView, setAuthView] = useState<'login' | 'register'>('login');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('auth') === 'true') {
      setOpenAuthModal(true);
    }
  }, []);

  const handleClose = useCallback(() => setOpenAuthModal(false), []);

  const handleSuccess = useCallback(() => {
    setOpenAuthModal(false);
    toast.success('Вы успешно вошли!');
    router.replace(pathname);
  }, [router, pathname]);

  const openLoginModal = useCallback(() => {
    prefetchAllAuth();
    setAuthView('login');
    setOpenAuthModal(true);
  }, []);

  const openRegisterModal = useCallback(() => {
    prefetchAllAuth();
    setAuthView('register');
    setOpenAuthModal(true);
  }, []);

  return (
    <>
      <section
        className="text-center bg-slate-800/50 p-4 rounded-lg"
        aria-labelledby="auth-heading"
      >
        <h2 id="auth-heading" className="sr-only">
          Аутентификация пользователя
        </h2>

        <p className="text-slate-300">
          <button
            onClick={openLoginModal}
            onPointerEnter={prefetchAllAuth}
            onFocus={prefetchAllAuth}
            onTouchStart={prefetchAllAuth}
            className="text-sky-400 hover:underline font-semibold cursor-pointer"
            aria-label="Войти в свою учетную запись"
          >
            Войдите
          </button>{' '}
          или{' '}
          <button
            onClick={openRegisterModal}
            onPointerEnter={prefetchAllAuth}
            onFocus={prefetchAllAuth}
            onTouchStart={prefetchAllAuth}
            className="text-sky-400 hover:underline font-semibold cursor-pointer"
            aria-label="Создать новую учетную запись"
          >
            зарегистрируйтесь
          </button>
        </p>

        <p className="text-slate-400 mt-1">
          чтобы публиковать любые интересные фото — от красивой радуги до снегопада — и обсуждать
          их в комментариях.
        </p>
      </section>

      {openAuthModal && (
        <Suspense
          fallback={
            <div aria-live="polite" className="sr-only">
              Загрузка...
            </div>
          }
        >
          <AuthModal
            open={openAuthModal}
            onClose={handleClose}
            onSuccess={handleSuccess}
            redirectPath="/reporter"
            initialView={authView}
          />
        </Suspense>
      )}
    </>
  );
}

export default memo(AuthLinks);
